document.addEventListener('DOMContentLoaded', () => {
    if (!document.getElementById('quiz-body')) return;

    // Quiz Questions Definition
    const quizQuestions = [
        {
            question: "What would you like to enhance?",
            options: [
                "Define my waist",
                "Smooth my tummy",
                "Shape my curves",
                "Everyday comfort"
            ]
        },
        {
            question: "What's your priority?",
            options: [
                "Everyday Comfort",
                "Smooth Under Clothes",
                "Strong Sculpting",
                "Light Shaping"
            ]
        },
        {
            question: "What are you wearing it with?",
            options: [
                "Everyday Outfits",
                "Dresses",
                "Jeans",
                "Special Occasions"
            ]
        },
        {
            question: "Which style do you prefer?",
            options: [
                "Bodysuits",
                "Briefs & Panties",
                "Shorts",
                "Bras & Tops"
            ]
        },
        {
            question: "What is your typical clothing size?",
            options: [
                "XS / S",
                "M / L",
                "XL / 2XL",
                "3XL / 4XL"
            ]
        }
    ];

    let currentStep = 0;
    let selectedOptions = new Array(quizQuestions.length).fill(null);
    const quizBody = document.getElementById('quiz-body');

    // UI Rendering Logic
    function renderStep() {
        quizBody.classList.remove('fade-enter-active');
        void quizBody.offsetWidth; // trigger reflow
        
        const q = quizQuestions[currentStep];
        let optionsHtml = '';
        
        q.options.forEach((opt, index) => {
            const isSelected = selectedOptions[currentStep] === index;
            optionsHtml += `
                <label class="option-label ${isSelected ? 'selected' : ''} flex items-center p-5 border border-espresso/20 rounded-md cursor-pointer hover:border-espresso transition-colors mb-4 bg-white/50">
                    <input type="radio" name="q${currentStep}" value="${index}" class="hidden" onchange="window.selectQuizOption(${index})" ${isSelected ? 'checked' : ''} />
                    <div class="w-5 h-5 rounded-full border border-espresso/50 mr-4 flex items-center justify-center shrink-0 transition-colors">
                        <div class="w-2.5 h-2.5 bg-espresso rounded-full ${isSelected ? 'opacity-100 scale-100' : 'opacity-0 scale-50'} transition-all duration-200"></div>
                    </div>
                    <span class="font-body-md text-espresso text-lg">${opt}</span>
                </label>
            `;
        });

        quizBody.innerHTML = `
            <div class="text-secondary text-sm font-label-caps uppercase tracking-widest mb-6 text-center font-bold">
                Question ${currentStep + 1} of ${quizQuestions.length}
            </div>
            
            <h2 class="font-headline-lg text-2xl md:text-3xl text-espresso mb-8 text-center font-medium">${q.question}</h2>
            
            <div class="flex flex-col w-full mb-10">
                ${optionsHtml}
            </div>
            
            <div class="text-center w-full">
                <button id="continue-btn" onclick="window.nextQuizStep()" class="${selectedOptions[currentStep] !== null ? 'bg-espresso hover:bg-terracotta' : 'bg-espresso/30 cursor-not-allowed'} text-ivory font-button text-sm py-4 px-12 uppercase tracking-widest transition-colors rounded-sm shadow-sm inline-flex items-center justify-center gap-2" ${selectedOptions[currentStep] !== null ? '' : 'disabled'}>
                    CONTINUE <span class="material-symbols-outlined text-[18px]">arrow_forward</span>
                </button>
            </div>
        `;
        
        setTimeout(() => {
            quizBody.classList.add('fade-enter-active');
        }, 50);
    }

    window.selectQuizOption = function(index) {
        selectedOptions[currentStep] = index;
        renderStep();
    };

    window.nextQuizStep = function() {
        if (selectedOptions[currentStep] === null) return;
        
        if (currentStep < quizQuestions.length - 1) {
            currentStep++;
            renderStep();
        } else {
            processQuizAndShowResults();
        }
    };

    // Helper functions for matching
    function containsAny(text, keywords) {
        if (!text) return false;
        text = text.toLowerCase();
        return keywords.some(kw => text.includes(kw));
    }

    function checkSizeAvailability(product, sizeLabel) {
        // Map size labels to typical Shopify variant option values
        let sizesToLookFor = [];
        if (sizeLabel === "XS / S") sizesToLookFor = ["xs", "s", "xs/s"];
        else if (sizeLabel === "M / L") sizesToLookFor = ["m", "l", "m/l"];
        else if (sizeLabel === "XL / 2XL") sizesToLookFor = ["xl", "xxl", "2xl", "xl/2xl", "1x", "2x"];
        else if (sizeLabel === "3XL / 4XL") sizesToLookFor = ["3xl", "4xl", "3x", "4x"];

        if(sizesToLookFor.length === 0) return true;

        for (const variant of product.variants) {
            if (!variant.available) continue;
            
            // Check all 3 options
            const opt1 = (variant.option1 || "").toLowerCase();
            const opt2 = (variant.option2 || "").toLowerCase();
            const opt3 = (variant.option3 || "").toLowerCase();

            if (sizesToLookFor.some(s => opt1 === s || opt2 === s || opt3 === s || opt1.includes(s) || opt2.includes(s))) {
                return true;
            }
        }
        return false;
    }

    // SCORING ENGINE
    function calculateProductScores() {
        const products = window.bodyCurvyProducts || [];
        const ansGoal = quizQuestions[0].options[selectedOptions[0]];
        const ansPriority = quizQuestions[1].options[selectedOptions[1]];
        const ansOutfit = quizQuestions[2].options[selectedOptions[2]];
        const ansStyle = quizQuestions[3].options[selectedOptions[3]];
        const ansSize = quizQuestions[4].options[selectedOptions[4]];

        let scoredProducts = products.map(p => {
            let score = 0;
            const tText = (p.title + " " + p.description + " " + p.tags.join(" ") + " " + p.type).toLowerCase();
            let reasons = [];

            // 1. Goal (Weight: 30)
            if (ansGoal === "Define my waist") {
                if (containsAny(tText, ['waist', 'cincher', 'hourglass'])) { score += 30; reasons.push("Targeted waist definition aligned with your shaping goal."); }
            } else if (ansGoal === "Smooth my tummy") {
                if (containsAny(tText, ['tummy', 'stomach', 'core', 'control'])) { score += 30; reasons.push("Core smoothing specifically designed for tummy control."); }
            } else if (ansGoal === "Shape my curves") {
                if (containsAny(tText, ['curve', 'sculpt', 'full body', 'enhance'])) { score += 30; reasons.push("Full sculpting power to enhance your natural curves."); }
            } else if (ansGoal === "Everyday comfort") {
                if (containsAny(tText, ['comfort', 'everyday', 'light', 'soft'])) { score += 30; reasons.push("Breathable fabric ideal for everyday comfortable wear."); }
            }

            // 2. Priority (Weight: 20)
            if (ansPriority === "Everyday Comfort") {
                if (containsAny(tText, ['comfort', 'light', 'seamless', 'wirefree'])) { score += 20; reasons.push("Prioritizes comfort without sacrificing support."); }
            } else if (ansPriority === "Smooth Under Clothes") {
                if (containsAny(tText, ['seamless', 'invisible', 'smooth'])) { score += 20; reasons.push("Seamless construction remains totally invisible under clothes."); }
            } else if (ansPriority === "Strong Sculpting") {
                if (containsAny(tText, ['firm', 'strong', 'high compression', 'sculpt'])) { score += 20; reasons.push("Firm compression delivers powerful sculpting results."); }
            } else if (ansPriority === "Light Shaping") {
                if (containsAny(tText, ['light', 'smooth', 'gentle'])) { score += 20; reasons.push("Light shaping offers a gentle, natural smoothing effect."); }
            }

            // 3. Outfit (Weight: 15)
            if (ansOutfit === "Everyday Outfits") {
                if (containsAny(tText, ['everyday', 'basic'])) score += 15;
            } else if (ansOutfit === "Dresses") {
                if (containsAny(tText, ['bodysuit', 'slip', 'dress', 'thong'])) { score += 15; reasons.push("Perfect cut and seamless finish for wearing under dresses."); }
            } else if (ansOutfit === "Jeans") {
                if (containsAny(tText, ['short', 'brief', 'panty'])) { score += 15; reasons.push("Ideal length and style to pair perfectly with jeans."); }
            } else if (ansOutfit === "Special Occasions") {
                if (containsAny(tText, ['firm', 'corset', 'sculpt'])) score += 15;
            }

            // 4. Style (Weight: 25)
            const typeLower = (p.type || "").toLowerCase();
            const tagsLower = p.tags.join(" ").toLowerCase();
            const titleLower = p.title.toLowerCase();

            if (ansStyle === "Bodysuits") {
                if (typeLower.includes('bodysuit') || titleLower.includes('bodysuit') || tagsLower.includes('bodysuit')) {
                    score += 25; reasons.push("Your preferred bodysuit style for all-over smoothing.");
                }
            } else if (ansStyle === "Briefs & Panties") {
                if (typeLower.includes('brief') || typeLower.includes('panty') || typeLower.includes('thong') || titleLower.includes('brief') || titleLower.includes('panty')) {
                    score += 25; reasons.push("Your preferred brief style for targeted lower-body control.");
                }
            } else if (ansStyle === "Shorts") {
                if (typeLower.includes('short') || titleLower.includes('short')) {
                    score += 25; reasons.push("Your preferred short style to prevent thigh chafing.");
                }
            } else if (ansStyle === "Bras & Tops") {
                if (typeLower.includes('bra') || typeLower.includes('top') || typeLower.includes('cami') || titleLower.includes('bra') || titleLower.includes('cami')) {
                    score += 25; reasons.push("Your preferred top style for upper-body support.");
                }
            }

            // Size filtering logic
            const hasSize = checkSizeAvailability(p, ansSize);

            // If reasons is empty, add some generics based on score
            if (reasons.length === 0) {
                reasons.push("Perfectly matches your overall body goals.");
                reasons.push("Highly rated by customers with similar preferences.");
                reasons.push("Versatile design for your selected outfits.");
            }

            // Max reasons to 3
            reasons = reasons.slice(0, 3);

            return {
                product: p,
                score: score,
                hasSize: hasSize,
                reasons: reasons
            };
        });

        // Sort: First by size availability, then by score
        scoredProducts.sort((a, b) => {
            if (a.hasSize && !b.hasSize) return -1;
            if (!a.hasSize && b.hasSize) return 1;
            return b.score - a.score;
        });

        return scoredProducts;
    }

    function processQuizAndShowResults() {
        document.getElementById('quiz-header').classList.add('hidden');
        quizBody.classList.add('hidden');
        
        const loadingScreen = document.getElementById('loading-screen');
        loadingScreen.classList.remove('hidden');
        loadingScreen.style.display = 'flex'; // Use flex since it has flex-col

        // Analytics Hook
        if(window.Shopify && Shopify.analytics) {
            // Future analytics tracking can go here
            console.log("BodyCurvy Match Quiz Completed", selectedOptions);
        }
        
        setTimeout(() => {
            const results = calculateProductScores();
            renderResults(results);

            loadingScreen.classList.add('hidden');
            loadingScreen.style.display = 'none';
            document.getElementById('results-screen').classList.remove('hidden');
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 2000);
    }

    function renderResults(results) {
        if(results.length === 0) return; // Edge case: empty store

        const winner = results[0];
        
        // Calculate dynamic match percentage (base 70 + (score / max_score 90) * 30) -> Max 100%
        let pct = Math.min(99, Math.max(70, Math.floor(70 + (winner.score / 90) * 29)));
        if (winner.score > 80) pct = 98; // High score bump
        
        document.getElementById('result-match-pct').textContent = `${pct}% MATCH`;
        document.getElementById('result-image').src = winner.product.image;
        document.getElementById('result-title').textContent = winner.product.title;
        document.getElementById('result-link').href = winner.product.url;

        let subtitle = winner.product.type ? `Perfect for: ${winner.product.type}` : "Perfect for your body shape";
        document.getElementById('result-subtitle').textContent = subtitle;

        // Render Reasons
        const reasonsList = document.getElementById('result-reasons');
        reasonsList.innerHTML = winner.reasons.map(r => `
            <li class="flex items-start gap-3">
                <span class="material-symbols-outlined text-terracotta text-[20px] shrink-0">check_circle</span>
                <span class="text-espresso/80 font-body-md text-sm md:text-base leading-snug">${r}</span>
            </li>
        `).join('');

        // Secondary Recommendations
        const secondaryContainer = document.getElementById('secondary-recommendations-container');
        const secondaryGrid = document.getElementById('secondary-recommendations');
        
        if (results.length > 1) {
            secondaryContainer.style.display = 'block';
            let secondaryHtml = '';
            
            // Get up to 2 runner ups
            for (let i = 1; i <= Math.min(2, results.length - 1); i++) {
                const runnerUp = results[i];
                let runnerPct = Math.min(pct - (i * 4), Math.floor(65 + (runnerUp.score / 90) * 30));
                
                secondaryHtml += `
                    <a href="${runnerUp.product.url}" class="flex flex-col group cursor-pointer text-left relative">
                        <div class="relative aspect-[4/5] bg-nude-warm mb-3 overflow-hidden rounded-[2px]">
                            <div class="absolute top-2 left-2 bg-ivory/90 text-espresso font-bold text-[10px] uppercase tracking-widest px-2 py-1 z-10 rounded-[2px]">${runnerPct}% MATCH</div>
                            <img class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" src="${runnerUp.product.image}" alt="${runnerUp.product.title}" />
                        </div>
                        <h5 class="font-label-caps text-[11px] text-espresso uppercase mb-1 truncate">${runnerUp.product.title}</h5>
                    </a>
                `;
            }
            secondaryGrid.innerHTML = secondaryHtml;
        } else {
            secondaryContainer.style.display = 'none';
        }
    }

    // Start
    renderStep();
});
